import { Badge } from '@staff-app/ui';
import type { TroubleshootSession } from '../hooks/useTroubleshoot';

/**
 * "Staff" marker for a session a staff member started (`mode === 'staff'`). The customer sees such a
 * session as "OptiSigns Support" (open-api masks the actor for them); staff-app keeps the operator's
 * email and flags the row with this badge instead. Renders nothing for customer-started sessions.
 */
export function StaffSessionBadge({ mode }: Pick<TroubleshootSession, 'mode'>) {
  if (mode !== 'staff') return null;
  return (
    <Badge
      variant="outline"
      className="shrink-0 border-primary/40 text-[10px] text-primary"
      data-testid="troubleshoot-staff-badge"
    >
      {'Staff'}
    </Badge>
  );
}
